<ng-container *ngIf="value[CONSTANTS.name]">
  <a *ngIf="trueLink" (click)="openElementDialog()" class="adb-element-link">{{ value[CONSTANTS.name] }}</a>
  <span *ngIf="!trueLink">
    {{ value[CONSTANTS.name] }}
  </span>
</ng-container>